import BigNumber from "bignumber.js";
import { distinctBigNumberUntilChanged, sharePublishReplay, swalloError } from "ngx-libs";
import { Observable, of, timer } from "rxjs";
import { distinctUntilChanged, filter, map, mergeMap, switchMap,  take,  tap } from "rxjs/operators";
import DepositorAbi from "src/app/abi/depositor";
import { AccountService } from "../services/account.service";
import { ContractService } from "../services/contract.service";
import { EthWalletService } from "../services/eth-wallet.service";
import { Base } from "./base";
import { Market } from "./market";
import { PaymasterMethod } from "./paymaster-method";
import { environment } from "src/environments/environment";

export class Depositor extends Base {
  underlyingApproved: Observable<boolean>;
  underlyingAllowance: Observable<BigNumber>;

  constructor(
    protected contract: string,
    protected accountService: AccountService,
    protected contractService: ContractService,
    private ethWalletService: EthWalletService,
    private market: Market
  ) {
    super(contract, DepositorAbi, accountService,contractService);

    let approved = false;
    const account = this.accountService.account.pipe(
      distinctUntilChanged(),
      tap(() => {
        approved = false;
      })
    );

    this.underlyingAllowance = account.pipe(
      switchMap((a) =>
        timer(0, 5000).pipe(
          filter(() => !approved),
          switchMap(() =>
            a ? this.market.underlying.allowance(a, this.contract).pipe(swalloError()) : of(new BigNumber(0))
          )
        )
      ),
      distinctBigNumberUntilChanged()
    );

    this.underlyingApproved = this.underlyingAllowance.pipe(
      map((v) => v.gt(0)),
      tap((r) => {
        approved = r;
      }),
      sharePublishReplay(1)
    );
  }

  approveUnderlying(paymasterMethod?: PaymasterMethod) {
    return this.market.underlying.approveAll(this.contract, paymasterMethod);
  }

  tryDeposit(amount: any, paymasterMethod?: PaymasterMethod) {
    // if (environment.features.signedData) {
    //   return this.market.signedData.pipe(
    //     take(1),
    //     mergeMap((json) =>
    //       this.estimateGas((i, a) => i.methods.deposit(new BigNumber(amount).toDecimal().toString(10), a), {
    //         paymasterMethod,
    //         extraData: json.data
    //       })
    //     )
    //   );
    // } else {
      return this.estimateGas((i, a) => i.methods.deposit(new BigNumber(amount).toDecimal().toString(10), a));
    // }
  }

  deposit(amount: any, paymasterMethod?: PaymasterMethod) {
    // if (environment.features.signedData) {
    //   return this.market.api.oracles.getSignedData().pipe(
    //     mergeMap((json) =>
    //       this.send((i, a) => i.methods.deposit(new BigNumber(amount).toDecimal().toString(10), a), {
    //         paymasterMethod,
    //         extraData: json.data
    //       })
    //     )
    //   );
    // } else {
      return this.send((i, a) => i.methods.deposit(new BigNumber(amount).toDecimal().toString(10), a));
    // }
  }
}
